<template>
  <DrawerHeader @close="emit('close')"
    >Payment</DrawerHeader
  >
  <div
    class="flex flex-1 flex-col justify-center space-y-3 p-4"
  >
    <h1 class="text-center text-3xl font-bold">{{
      formatToMerchantCurrencyString(amountGross)
    }}</h1>
    <ActionButtonSecondary
      v-if="isSplitPaymentsEnabled"
      class="w-full"
      @click="emit('selectMethod', 'split')"
    >
      Split Payment
    </ActionButtonSecondary>
    <ActionButtonSecondary
      v-if="isCashEnabled"
      class="w-full"
      @click="emit('selectMethod', 'cash')"
    >
      Pay with cash
    </ActionButtonSecondary>
    <div class="flex space-x-1">
      <ActionButtonPrimary
        class="w-full"
        @click="emit('selectMethod', 'card')"
      >
        <div
          class="flex flex-row flex-nowrap items-center justify-center font-semibold"
        >
          <IconCard class="mr-2" />
          <span> Pay with card </span>
        </div>
      </ActionButtonPrimary>
      <ActionButtonPrimary
        v-if="cardholderNotPresentEnabled"
        @click="emit('selectMethod', 'CNP')"
      >
        <div
          class="flex flex-row flex-nowrap items-center justify-center font-semibold"
        >
          <IconPhoneFilled class="mr-2" />
          <span> CNP </span>
        </div>
      </ActionButtonPrimary>
    </div>
  </div>
</template>

<script setup lang="ts">
const { formatToMerchantCurrencyString } = useCurrency()

defineProps<{
  amountGross: number
}>()

const emit = defineEmits<{
  (
    event: "selectMethod",
    value: "cash" | "card" | "split" | "CNP"
  ): void
  (event: "close"): void
}>()

const { isCashEnabled, isSplitPaymentsEnabled } =
  useTenant()
const { cardholderNotPresentEnabled } =
  useCardholderNotPresent()
</script>
